import React from "react";

import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import ArtistBanner from "Pages/Artistsubmission/ArtistBanner";
import Artistsubmission from "../Pages/Artistsubmission/Artistsubmission";

import Latestupdate from "../Component/Latestupdate/Latestupdate";

export default function Artisttheme() {
  return (
    <>
      {/* <Header />
      <ArtistBanner /> */}
      <Artistsubmission />
      {/* <Latestupdate />
      <Footer /> */}
    </>
  );
}
